import { render, staticRenderFns } from "./OnlineBiddingRoom.vue?vue&type=template&id=64f18448&scoped=true&"
import script from "./OnlineBiddingRoom.vue?vue&type=script&lang=js&"
export * from "./OnlineBiddingRoom.vue?vue&type=script&lang=js&"
import style0 from "./OnlineBiddingRoom.vue?vue&type=style&index=0&id=64f18448&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f18448",
  null
  
)

export default component.exports